import { EventBus, EventBusStubTransport } from './common/events';
import { HousesEditorServiceStub } from './services/HousesEditorServiceStub';
import {
	AccessControlService,
	AccessControlServiceStub,
	AccountsService,
	AccountsServiceStub,
	AdminService,
	AdminServiceStub,
	AdsService,
	AdsServiceStub,
	BackendService,
	BackendServiceStub,
	BankService,
	BankServiceStub,
	BarberShopService,
	BarberShopServiceStub,
	ButtonActionsServiceStub,
	CasesService,
	CasesServiceStub,
	CatchRingService,
	CatchRingServiceStub,
	CharacterCreationServiceStub,
	CharacterEditorServiceStub,
	CharacterSelectionServiceStub,
	CharacterSkillsServiceStub,
	ChatServiceStub,
	ClothesShopServiceStub,
	ClothesTesterServiceStub,
	ConfigService,
	ConfigServiceStub,
	ContactsService,
	ContactsServiceStub,
	DailyTasksService,
	DailyTasksServiceStub,
	DialogueService,
	DialogueServiceStub,
	DonateItemService,
	DonateItemServiceStub,
	DonateService,
	DonateServiceStub,
	DrivingSchoolServiceStub,
	EntitySearchService,
	EntitySearchServiceStub,
	ExchangeService,
	ExchangeServiceStub,
	FeedbackService,
	FeedbackServiceStub,
	GameCircuitServiceStub,
	GameConfigService,
	GameFishingServiceStub,
	GameServiceStub,
	GasStationServiceStub,
	GpsService,
	GpsServiceStub,
	GreenScreenServiceStub,
	GuiServiceStub,
	HandlingTuningService,
	HandlingTuningServiceStub,
	HelpModalService,
	HelpModalServiceStub,
	HousesService,
	HousesServiceStub,
	HudService,
	HudServiceStub,
	IAccessControlService,
	IAccountsService,
	IAdminService,
	IAdsService,
	IBankService,
	IBarberShopService,
	ICasesService,
	ICatchRingService,
	IConfigService,
	IContactsService,
	IDailyTasksService,
	IDialogueService,
	IDonateItemService,
	IDonateService,
	IEntitySearchService,
	IExchangeService,
	IFeedbackService,
	IGasStationService,
	IGpsService,
	IHandlingTuningService,
	IHelpModalService,
	IHousesService,
	IHudService,
	IInventoryDonateService,
	IInventoryService,
	IJobElectricianService,
	IJobFarmerService,
	ILicensesService,
	ILootBuyersService,
	IMessagesService,
	IModalService,
	INotificationsService,
	InputServiceStub,
	InventoryDonateService,
	InventoryDonateServiceStub,
	InventoryService,
	InventoryServiceStub,
	IPhoneCallsService,
	IPhoneService,
	IPlayerService,
	IProductShopService,
	IPromoService,
	IReportService,
	IRockPaperScissorsService,
	ISoundsService,
	ISpawnSelectService,
	IStatsService,
	ITabletService,
	ITattooShopService,
	ITechTuningService,
	IVehicleNumberPlateService,
	IVehicleService,
	IVehicleShopService,
	IWeatherService,
	IBetaRewardsService,
	JobElectricianService,
	JobFarmerService,
	JobFarmerServiceStub,
	JobsServiceStub,
	LicensesService,
	LicensesServiceStub,
	LootBuyersService,
	LootBuyersServiceStub,
	MessagesService,
	MessagesServiceStub,
	ModalService,
	ModalServiceStub,
	NotificationsService,
	NotificationsServiceStub,
	PhoneCallsService,
	PhoneCallsServiceStub,
	PhoneService,
	PhoneServiceStub,
	PhotoModeServiceStub,
	PlayerService,
	PlayerServiceStub,
	ProductShopService,
	ProductShopServiceStub,
	PromoService,
	PromoServiceStub,
	QuestsServiceStub,
	RadialMenuServiceStub,
	ReportService,
	ReportServiceStub,
	RestrictionsServiceStub,
	RockPaperScissorsService,
	RockPaperScissorsStub,
	RpcServiceStub,
	RuncodeServiceStub,
	SoundsService,
	SoundsServiceStub,
	SpawnSelectService,
	SpawnSelectServiceStub,
	StatsService,
	StatsServiceStub,
	TabletService,
	TabletServiceStub,
	TattooShopService,
	TattooShopServiceStub,
	TechTuningService,
	TechTuningServiceStub,
	TuningTesterServiceStub,
	VarsService,
	VehicleMarketServiceStub,
	VehicleNumberPlateService,
	VehicleNumberPlateServiceStub,
	VehiclePaintShopServiceStub,
	VehiclePassportServiceStub,
	VehicleRegistrationServiceStub,
	VehicleService,
	VehicleServiceStationServiceStub,
	VehicleServiceStub,
	VehicleShopService,
	VehicleShopServiceStub,
	VehicleTuningShopServiceStub,
	WeatherService,
	BetaRewardsService,
	BetaRewardsServiceStub,
	WeatherServiceStub,
} from './services';
import { IRageClient } from './types';

export class RageClientStub implements IRageClient {
	public readonly bank: IBankService;
	public readonly search: IEntitySearchService;
	public readonly player: IPlayerService;
	public readonly accounts: IAccountsService;
	public readonly vehicleShop: IVehicleShopService;
	public readonly backend: Pick<BackendService, 'waitForInit'>;
	public readonly vehicles: IVehicleService;
	public readonly config: IConfigService;
	public readonly gameConfig: GameConfigService;
	public readonly vehicleNumberPlates: IVehicleNumberPlateService;
	public readonly licenses: ILicensesService;
	public readonly houses: IHousesService;
	public readonly modal: IModalService;
	public readonly notifications: INotificationsService;
	public readonly handlingTuning: IHandlingTuningService;
	public readonly exchange: IExchangeService;
	public readonly cases: ICasesService;
	public readonly dailyTasks: IDailyTasksService;
	public readonly promo: IPromoService;
	public readonly donateItem: IDonateItemService;
	public readonly tablet: ITabletService;
	public readonly jobElectrician: IJobElectricianService;
	public readonly inventory: IInventoryService;
	public readonly admin: IAdminService;
	public readonly tattooShop: ITattooShopService;
	public readonly reports: IReportService;
	public readonly messages: IMessagesService;
	public readonly contacts: IContactsService;
	public readonly ads: IAdsService;
	public readonly phone: IPhoneService;
	public readonly phoneCalls: IPhoneCallsService;
	public readonly gps: IGpsService;
	public readonly stats: IStatsService;
	public readonly techTuning: ITechTuningService;
	public readonly barberShop: IBarberShopService;
	public readonly productShop: IProductShopService;
	public readonly lootBuyers: ILootBuyersService;
	public readonly rockPaperScissors: IRockPaperScissorsService;
	public readonly hud: IHudService;
	public readonly jobFarmer: IJobFarmerService;
	public readonly helpModal: IHelpModalService;
	public readonly catchRing: ICatchRingService;
	public readonly weather: IWeatherService;
	public readonly betaRewards: IBetaRewardsService;
	public readonly donate: IDonateService;
	public readonly inventoryDonate: IInventoryDonateService;
	public readonly spawnSelect: ISpawnSelectService;
	public readonly feedback: IFeedbackService;
	public readonly sounds: ISoundsService;
	public readonly accessControl: IAccessControlService;
	public readonly dialogues: IDialogueService;
	public readonly gasStation: IGasStationService;

	public readonly gui = new GuiServiceStub();
	public readonly game = new GameServiceStub();
	public readonly chat = new ChatServiceStub();
	public readonly input = new InputServiceStub();
	public readonly jobs = new JobsServiceStub();
	public readonly drivingSchool = new DrivingSchoolServiceStub();
	public readonly photoMode = new PhotoModeServiceStub();
	public readonly clothesShop = new ClothesShopServiceStub();
	public readonly vehiclePaintShop = new VehiclePaintShopServiceStub();
	public readonly vehicleTuningShop = new VehicleTuningShopServiceStub();
	public readonly characterCreation = new CharacterCreationServiceStub();
	public readonly characterEditor = new CharacterEditorServiceStub();
	public readonly radialMenu = new RadialMenuServiceStub();
	public readonly vehiclePassport = new VehiclePassportServiceStub();
	public readonly greenScreen = new GreenScreenServiceStub();
	public readonly quests = new QuestsServiceStub();
	public readonly restrictions = new RestrictionsServiceStub();
	public readonly buttonActions = new ButtonActionsServiceStub();
	public readonly clothesTester = new ClothesTesterServiceStub();
	public readonly housesEditor = new HousesEditorServiceStub();
	public readonly vehicleRegistration = new VehicleRegistrationServiceStub();
	public readonly vehicleMarket = new VehicleMarketServiceStub();
	public readonly gameFishing = new GameFishingServiceStub();
	public readonly tuningTester: TuningTesterServiceStub;
	public readonly vehicleServiceStation =
		new VehicleServiceStationServiceStub();
	public readonly characterSelection = new CharacterSelectionServiceStub();
	public readonly skills = new CharacterSkillsServiceStub();
	public readonly runcode = new RuncodeServiceStub();

	constructor() {
		console.log('[RageClientStub] Initializing');

		EventBus.setTransport(new EventBusStubTransport());

		const useRealBackend = import.meta.env.VITE_DEV_BACKEND === 'true';

		const rpc = new RpcServiceStub();
		if (useRealBackend) {
			console.log('Using real backend');

			const vars = new VarsService(rpc);

			this.config = new ConfigService();
			const backend = new BackendService(rpc);
			this.gameConfig = new GameConfigService(rpc, backend);
			const gameConfig = this.gameConfig;

			this.backend = backend;
			this.notifications = new NotificationsService(rpc, backend);
			this.modal = new ModalService(backend, this.notifications, this.gui);
			this.search = new EntitySearchService(backend, rpc);
			this.vehicles = new VehicleService(rpc, vars, gameConfig, backend);
			this.gasStation = new GasStationServiceStub(this.vehicles);
			this.player = new PlayerService(
				vars,
				backend,
				this.modal,
				this.notifications,
				gameConfig,
				this.vehicles,
			);
			this.bank = new BankService(
				backend,
				gameConfig,
				this.notifications,
				rpc,
				this.player,
			);
			this.accounts = new AccountsService(rpc, this.backend as BackendService);
			this.vehicleShop = new VehicleShopService(
				rpc,
				this.player,
				backend,
				this.notifications,
				gameConfig,
				vars,
			);
			this.vehicleNumberPlates = new VehicleNumberPlateService(
				backend,
				this.vehicles,
				rpc,
				this.notifications,
				gameConfig,
				vars,
			);
			this.licenses = new LicensesService(backend, gameConfig);
			this.houses = new HousesService(
				backend,
				this.player,
				gameConfig,
				rpc,
				this.notifications,
				this.modal,
			);
			this.handlingTuning = new HandlingTuningService(
				rpc,
				backend,
				this.vehicles,
				this.player,
				gameConfig,
				vars,
			);
			this.exchange = new ExchangeService(
				backend,
				this.player,
				this.notifications,
				rpc,
				gameConfig,
			);
			this.cases = new CasesService(
				backend,
				gameConfig,
				this.notifications,
				this.vehicles,
			);
			this.dailyTasks = new DailyTasksService(
				backend,
				this.notifications,
				gameConfig,
			);
			this.promo = new PromoService(
				backend,
				rpc,
				this.player as PlayerService,
				this.notifications as NotificationsService,
			);
			this.donateItem = new DonateItemService(rpc);
			this.jobFarmer = new JobFarmerService(rpc, gameConfig);
			this.jobElectrician = new JobElectricianService(rpc, gameConfig);
			this.tablet = new TabletService(rpc);
			this.inventory = new InventoryService(
				this.player,
				backend,
				vars,
				gameConfig,
				rpc,
				this.notifications,
			);
			this.admin = new AdminService(backend, rpc, vars);
			this.tattooShop = new TattooShopService(backend, gameConfig, rpc);
			this.ads = new AdsService(
				gameConfig,
				backend,
				this.notifications,
				this.player,
			);
			this.contacts = new ContactsService(backend);
			this.accessControl = new AccessControlService(vars, gameConfig);
			this.reports = new ReportService(
				backend,
				rpc,
				this.player,
				this.notifications,
			);
			this.phone = new PhoneService(rpc, vars, backend);
			this.messages = new MessagesService(rpc);
			this.phoneCalls = new PhoneCallsService(rpc, backend);
			this.gps = new GpsService(rpc, vars);
			this.stats = new StatsService(rpc, backend);
			this.techTuning = new TechTuningService(
				backend,
				gameConfig,
				rpc,
				this.vehicles,
			);
			this.barberShop = new BarberShopService(backend, gameConfig, rpc);
			this.productShop = new ProductShopService(gameConfig, rpc, backend, vars);
			this.lootBuyers = new LootBuyersService(
				rpc,
				backend,
				vars,
				gameConfig,
				this.player,
			);
			this.helpModal = new HelpModalService(vars, gameConfig);
			this.catchRing = new CatchRingService(rpc, vars);
			this.rockPaperScissors = new RockPaperScissorsService(rpc, vars);
			this.weather = new WeatherService(vars);
			this.betaRewards = new BetaRewardsService(gameConfig, rpc, backend);
			this.hud = new HudService(vars, this.dailyTasks);
			this.donate = new DonateService(vars, backend, gameConfig);
			this.inventoryDonate = new InventoryDonateService(
				backend,
				this.cases,
				gameConfig,
			);
			this.spawnSelect = new SpawnSelectService(vars, rpc);
			this.feedback = new FeedbackService(backend, rpc, this.notifications);
			this.dialogues = new DialogueService(
				gameConfig,
				backend,
				rpc,
				vars,
				this.notifications,
			);
			this.sounds = new SoundsService(rpc, vars);

			(this.backend as BackendService)
				.localConnect()
				.catch((err) => this.notifications.showException(err));
		} else {
			this.config = new ConfigServiceStub();
			this.backend = new BackendServiceStub();
			this.gameConfig = new GameConfigService(
				rpc,
				this.backend as BackendService,
			);
			this.bank = new BankServiceStub();
			this.search = new EntitySearchServiceStub();
			this.modal = new ModalServiceStub();
			this.player = new PlayerServiceStub(this.modal);
			this.accounts = new AccountsServiceStub();
			this.vehicleShop = new VehicleShopServiceStub();
			this.vehicles = new VehicleServiceStub();
			this.gasStation = new GasStationServiceStub(this.vehicles);
			this.vehicleNumberPlates = new VehicleNumberPlateServiceStub();
			this.licenses = new LicensesServiceStub();
			this.houses = new HousesServiceStub();
			this.notifications = new NotificationsServiceStub();
			this.handlingTuning = new HandlingTuningServiceStub(this.vehicles);
			this.exchange = new ExchangeServiceStub();
			this.cases = new CasesServiceStub();
			this.dailyTasks = new DailyTasksServiceStub();
			this.promo = new PromoServiceStub();
			this.donateItem = new DonateItemServiceStub();
			this.gameFishing = new GameFishingServiceStub();
			this.jobFarmer = new JobFarmerServiceStub();
			this.jobElectrician = new GameCircuitServiceStub();
			this.tablet = new TabletServiceStub();
			this.inventory = new InventoryServiceStub();
			this.admin = new AdminServiceStub();
			this.tattooShop = new TattooShopServiceStub();
			this.reports = new ReportServiceStub();
			this.contacts = new ContactsServiceStub();
			this.ads = new AdsServiceStub();
			this.phone = new PhoneServiceStub();
			this.messages = new MessagesServiceStub();
			this.phoneCalls = new PhoneCallsServiceStub();
			this.gps = new GpsServiceStub();
			this.stats = new StatsServiceStub();
			this.techTuning = new TechTuningServiceStub();
			this.barberShop = new BarberShopServiceStub();
			this.productShop = new ProductShopServiceStub();
			this.lootBuyers = new LootBuyersServiceStub();
			this.helpModal = new HelpModalServiceStub();
			this.catchRing = new CatchRingServiceStub();
			this.rockPaperScissors = new RockPaperScissorsStub();
			this.weather = new WeatherServiceStub();
			this.betaRewards = new BetaRewardsServiceStub();
			this.hud = new HudServiceStub();
			this.donate = new DonateServiceStub();
			this.inventoryDonate = new InventoryDonateServiceStub();
			this.spawnSelect = new SpawnSelectServiceStub();
			this.feedback = new FeedbackServiceStub();
			this.accessControl = new AccessControlServiceStub();
			this.dialogues = new DialogueServiceStub(this.notifications);
			this.sounds = new SoundsServiceStub();
		}
		this.tuningTester = new TuningTesterServiceStub(this.input);
	}
}
